<div class="relative">
  <loading-overlay [isLoading]="loading()" />

  @if (componentRows().length > 0) {
    <section class="section-block">
      <h3 class="section-title">{{ 'Cost_Analysis_Component_Summary' | translateWF: 'Component Summary' }}</h3>
      <p-table [value]="visibleRows()" styleClass="component-table" [stripedRows]="true" sortMode="single">
        <ng-template pTemplate="header">
          <tr>
            <th pSortableColumn="label">
              {{ 'Cost_Analysis_Component' | translateWF: 'Component' }}
              <p-sortIcon field="label" />
            </th>
            <th class="num-col" pSortableColumn="realPerLb">
              {{ 'Cost_Analysis_Real' | translateWF: 'Real' }} ($/lb)
              <p-sortIcon field="realPerLb" />
            </th>
            <th class="num-col" pSortableColumn="stdPerLb">
              {{ 'Cost_Analysis_Std' | translateWF: 'Standard' }} ($/lb)
              <p-sortIcon field="stdPerLb" />
            </th>
            <th class="num-col" pSortableColumn="variancePerLb">
              {{ 'Cost_Analysis_Variance' | translateWF: 'Variance' }} ($/lb)
              <p-sortIcon field="variancePerLb" />
            </th>
            <th class="num-col" pSortableColumn="variancePct">
              {{ 'Cost_Analysis_Variance_Pct' | translateWF: 'Variance %' }}
              <p-sortIcon field="variancePct" />
            </th>
            <th class="num-col" pSortableColumn="pctOfTotal">
              {{ 'Cost_Analysis_Pct_Total' | translateWF: '% of Total' }}
              <p-sortIcon field="pctOfTotal" />
            </th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-row>
          <tr [class.rm-row]="row.isRawMaterial">
            <td>
              @if (row.isWasteParent) {
                <button
                  type="button"
                  class="inline-flex items-center gap-2 text-left hover:text-[var(--p-primary-color)] transition-colors"
                  (click)="toggleWasteExpand()"
                  [attr.aria-expanded]="expandedWaste()"
                >
                  <i class="pi text-[0.7rem]" [class.pi-chevron-down]="expandedWaste()" [class.pi-chevron-right]="!expandedWaste()"></i>
                  <span class="component-label">{{ 'Cost_Analysis_Component_Process_Loss' | translateWF: 'Process Loss' }}</span>
                </button>
              } @else if (row.isWasteChild) {
                <span class="component-label pl-6 text-[var(--p-text-muted-color)]">{{ row.label }}</span>
              } @else {
                <span class="component-label">{{ row.label }}</span>
              }
            </td>
            <td class="num-col" [class.variance-good]="row.stdPerLb > 0 && row.variancePerLb < -0.0001" [class.variance-bad]="row.stdPerLb > 0 && row.variancePerLb > 0.0001">
              ${{ row.realPerLb | number: '1.4-4' }}
            </td>
            <td class="num-col">
              @if (row.stdPerLb > 0) {
                ${{ row.stdPerLb | number: '1.4-4' }}
              } @else {
                <span class="cell-dash">—</span>
              }
            </td>
            <td class="num-col" [class.variance-good]="row.stdPerLb > 0 && row.variancePerLb < -0.0001" [class.variance-bad]="row.stdPerLb > 0 && row.variancePerLb > 0.0001">
              @if (row.stdPerLb > 0) {
                @if (row.variancePerLb > 0.0001) {
                  <i class="pi pi-arrow-up variance-arrow"></i>
                } @else if (row.variancePerLb < -0.0001) {
                  <i class="pi pi-arrow-down variance-arrow"></i>
                }
                ${{ row.variancePerLb | number: '1.4-4' }}
              } @else {
                <span class="cell-dash">—</span>
              }
            </td>
            <td
              class="num-col"
              [class.variance-good]="row.variancePct !== null && row.variancePerLb < -0.0001"
              [class.variance-bad]="row.variancePct !== null && row.variancePerLb > 0.0001"
            >
              @if (row.variancePct !== null) {
                @if (row.variancePerLb > 0.0001) {
                  <i class="pi pi-arrow-up variance-arrow"></i>
                } @else if (row.variancePerLb < -0.0001) {
                  <i class="pi pi-arrow-down variance-arrow"></i>
                }
                {{ row.variancePct | number: '1.1-1' }}%
              } @else {
                <span class="cell-dash">—</span>
              }
            </td>
            <td class="num-col">{{ row.pctOfTotal | number: '1.1-1' }}%</td>
          </tr>
        </ng-template>
        <ng-template pTemplate="footer">
          <tr class="totals-row">
            <td>
              <strong>{{ 'Cost_Analysis_Grand_Total' | translateWF: 'Total' }}</strong>
            </td>
            <td class="num-col">
              <strong>${{ componentTotals().sumOfProcessCostPerLb | number: '1.4-4' }}</strong>
            </td>
            <td class="num-col">
              @if (componentTotals().totalStdPerLb > 0) {
                <strong>${{ componentTotals().totalStdPerLb | number: '1.4-4' }}</strong>
              } @else {
                <span class="cell-dash">—</span>
              }
            </td>
            <td
              class="num-col"
              [class.variance-good]="componentTotals().totalStdPerLb > 0 && componentTotals().totalVariancePerLb < -0.0001"
              [class.variance-bad]="componentTotals().totalStdPerLb > 0 && componentTotals().totalVariancePerLb > 0.0001"
            >
              @if (componentTotals().totalStdPerLb > 0) {
                <strong>${{ componentTotals().totalVariancePerLb | number: '1.4-4' }}</strong>
              } @else {
                <span class="cell-dash">—</span>
              }
            </td>
            <td
              class="num-col"
              [class.variance-good]="componentTotals().totalVariancePct !== null && componentTotals().totalVariancePerLb < -0.0001"
              [class.variance-bad]="componentTotals().totalVariancePct !== null && componentTotals().totalVariancePerLb > 0.0001"
            >
              @if (componentTotals().totalVariancePct !== null) {
                <strong>{{ componentTotals().totalVariancePct | number: '1.1-1' }}%</strong>
              } @else {
                <span class="cell-dash">—</span>
              }
            </td>
            <td class="num-col">
              <strong>{{ componentTotals().pctOfTotal | number: '1.1-1' }}%</strong>
            </td>
          </tr>
        </ng-template>
      </p-table>
    </section>

    <section class="section-block mt-6">
      <h3 class="section-title">{{ 'Cost_Analysis_Component_Process_Matrix' | translateWF: 'Component × Process Matrix ($/lb)' }}</h3>
      <p-table [value]="visibleRows()" styleClass="matrix-table" [stripedRows]="true" [scrollable]="true" scrollHeight="flex" sortMode="single">
        <ng-template pTemplate="header">
          <tr>
            <th class="comp-col" pSortableColumn="label">
              {{ 'Cost_Analysis_Component' | translateWF: 'Component' }}
              <p-sortIcon field="label" />
            </th>
            <th class="num-col total-col" pSortableColumn="totalCostPerLbUsd">
              {{ 'Cost_Analysis_Total' | translateWF: 'Total' }} ($/lb)
              <p-sortIcon field="totalCostPerLbUsd" />
            </th>
            @for (process of processes; track process) {
              <th class="num-col proc-col" [pSortableColumn]="'byProcess.' + process">
                {{ processLabels[process] }}
                <p-sortIcon [field]="'byProcess.' + process" />
              </th>
            }
          </tr>
        </ng-template>

        <ng-template pTemplate="body" let-row>
          <tr [class.rm-row]="row.isRawMaterial">
            <td class="comp-col">
              @if (row.isWasteParent) {
                <button
                  type="button"
                  class="inline-flex items-center gap-2 text-left hover:text-[var(--p-primary-color)] transition-colors"
                  (click)="toggleWasteExpand()"
                  [attr.aria-expanded]="expandedWaste()"
                >
                  <i class="pi text-[0.7rem]" [class.pi-chevron-down]="expandedWaste()" [class.pi-chevron-right]="!expandedWaste()"></i>
                  <span class="component-label">{{ 'Cost_Analysis_Component_Process_Loss' | translateWF: 'Process Loss' }}</span>
                </button>
              } @else if (row.isWasteChild) {
                <span class="component-label pl-6 text-[var(--p-text-muted-color)]">{{ row.label }}</span>
              } @else {
                <span class="component-label">{{ row.label }}</span>
              }
            </td>
            <td class="num-col total-col">
              <strong>${{ rowTotalCostPerLb(row) | number: '1.4-4' }}</strong>
            </td>
            @for (process of processes; track process) {
              <td class="num-col proc-col" [class.cell-zero]="row.byProcess[process] === 0">
                @if (row.byProcess[process] > 0) {
                  ${{ row.byProcess[process] | number: '1.4-4' }}
                } @else {
                  <span class="cell-dash">—</span>
                }
              </td>
            }
          </tr>
        </ng-template>

        <ng-template pTemplate="footer">
          <tr class="totals-row">
            <td class="comp-col">
              <strong>{{ 'Cost_Analysis_Grand_Total' | translateWF: 'Total' }}</strong>
            </td>
            <td class="num-col total-col">
              <strong>${{ componentTotals().sumOfProcessCostPerLb | number: '1.4-4' }}</strong>
            </td>
            @for (process of processes; track process) {
              <td class="num-col proc-col">
                @if (componentTotals().byProcess[process] > 0) {
                  <strong>${{ componentTotals().byProcess[process] | number: '1.4-4' }}</strong>
                } @else {
                  <span class="cell-dash">—</span>
                }
              </td>
            }
          </tr>
        </ng-template>
      </p-table>
    </section>
  } @else if (!loading()) {
    <div class="empty-state">
      <i class="pi pi-sitemap" style="font-size: 2rem"></i>
      <p>{{ 'Cost_Analysis_No_Data' | translateWF: 'No data for the selected period.' }}</p>
    </div>
  }
</div>
